<div
  class="toolbar w-full px-gutter"
  fxLayout="row"
  fxLayoutAlign="start center"
  vexContainer>
  <button
    (click)="openSidenav()"
    class="drawerMenuButton"
    [fxHide]="!mobileQuery"
    mat-icon-button
    type="button"
    aria-label="menu">
    <mat-icon [icIcon]="icMenu"></mat-icon>
  </button>

  <!-- <button *ngIf="isHorizontalLayout$ | async"
          [fxHide]="mobileQuery"
          [matMenuTriggerFor]="addNewMenu"
          color="primary"
          mat-raised-button
          type="button">ADD NEW
  </button>

  <mat-menu #addNewMenu="matMenu" [overlapTrigger]="false" xPosition="after" yPosition="below">
    <button mat-menu-item>
      <mat-icon [icIcon]="icPersonAdd"></mat-icon>
      <span>Add Contact</span>
    </button>

    <button mat-menu-item>
      <mat-icon [icIcon]="icDoneAll"></mat-icon>
      <span>Add Task</span>
    </button>

    <button mat-menu-item>
      <mat-icon [icIcon]="icAssignmentTurnedIn"></mat-icon>
      <span>Add Project</span>
    </button>

    <button [matMenuTriggerFor]="documentMenu" mat-menu-item>
      <mat-icon [icIcon]="icBallot"></mat-icon>
      <span>Add Document</span>
    </button>
  </mat-menu> -->

  <!-- <mat-menu #documentMenu="matMenu">
    <button mat-menu-item>
      <mat-icon [icIcon]="icDescription"></mat-icon>
      <span>Add Quote</span>
    </button>

    <button mat-menu-item>
      <mat-icon [icIcon]="icAssignment"></mat-icon>
      <span>Add Invoice</span>
    </button>

    <button mat-menu-item>
      <mat-icon [icIcon]="icReceipt"></mat-icon>
      <span>Add Receipt</span>
    </button>
  </mat-menu> -->

  <!-- <div #megaMenuOriginRef class="ltr:ml-2 rtl:mr-2">
    <button *ngIf="isHorizontalLayout$ | async" [fxHide]="mobileQuery" (click)="openMegaMenu(megaMenuOriginRef)"
      color="primary" mat-button type="button">MEGA MENU
      <ic-icon [icon]="icArrowDropDown" class="ltr:-mr-1 rtl:-ml-1" inline="true"></ic-icon>
    </button>
  </div> -->

  <div
    *ngIf="(isVerticalLayout$ | async) && isNavbarInToolbar$ | async"
    [fxHide]="mobileQuery"
    class="px-gutter"
    fxFlex="none"
    fxLayout="row"
    fxLayoutAlign="start center">
    <vex-navigation-item
      *ngFor="let item of navigationItems"
      [item]="item"></vex-navigation-item>
  </div>

  <span fxFlex></span>

  <!-- Top Search bar -->
  <div
    class="search-box rounded-full border px-4"
    fxHide.xs
    fxFlex.lt-md="auto"
    fxLayout="row"
    fxLayoutAlign="start center">
    <!-- 
      [ngStyle]="{ width: selectedValue === 'jobs' ? '7%' : '13%' }" -->
    <mat-form-field floatLabel="never">
      <mat-select
        [(value)]="selectedValue"
        name="food"
        (selectionChange)="searchValueChange(selectedValue)">
        <mat-option *ngFor="let food of foods" [value]="food.value">
          {{ food.viewValue | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <input
      (ngModelChange)="onGetSearchValue($event)"
      class="search-text px-4 py-3 border-0 outline-none w-full bg-transparent"
      id="search"
      placeholder="{{ 'ENTER_JOB_CANDIDATE_SEARCH_CONTENT' | translate }} .."
      type="text"
      matInput
      [formControl]="myControl"
      [matAutocomplete]="auto"
      (keyup.enter)="gotoSearch()"
      aria-label="search" />
    <mat-autocomplete #auto="matAutocomplete"
      (optionSelected)="onOptionSelected($event)">
      <!-- <ng-container *ngIf="selectedValue === 'jobs'"> -->
      <mat-option
        *ngFor="let option of searchedData"
        (click)="getSearchResult(option)"
        (keyup.enter)="getSearchResult(option)"
        [value]="option.value">
        {{ option.label }}
      </mat-option>
      <!-- </ng-container> -->
      <!-- <ng-container *ngIf="selectedValue === 'candidates'">
        <mat-option *ngFor="let option of searchedData" (click)="getCandidateData(option)" [value]="option.RaterName">
          {{option.RaterName}}
        </mat-option>
      </ng-container> -->
    </mat-autocomplete>
    <ic-icon
      (click)="openSearchResult()"
      class="search-icon cursor-pointer"
      [icIcon]="icSearch"
      size="20px"></ic-icon>
    <a mat-flat-button (click)="openAdvancedSearch()">{{ 'ADVANCE' | translate }}</a>
  </div>

  <div class="-mx-1 flex flex-row items-center">
    <div class="px-1" fxHide.md fxHide.sm fxHide.gt-md>
      <button (click)="openSearch()" mat-icon-button type="button" aria-label="search">
        <mat-icon [icIcon]="icSearch"></mat-icon>
      </button>
    </div>

    <!-- History -->
    <div class="px-1">
      <vex-toolbar-history></vex-toolbar-history>
    </div>

    <!-- Notification -->
    <div class="px-1">
      <vex-toolbar-notifications></vex-toolbar-notifications>
    </div>

    <!-- Quick Panel -->
    <div class="px-1">
      <button
        (click)="openQuickpanel()"
        matTooltip="{{ 'EVENTS' | translate }}"
        mat-icon-button
        type="button"
        aria-label="bookmark">
        <mat-icon [icIcon]="icBookmarks"></mat-icon>
      </button>
    </div>

    <!-- Language select -->
    <button
      [matMenuTriggerFor]="languageMenu"
      matTooltip="{{ 'CHOOSE_LANGUAGE' | translate }}">
      <div class="flex flex-row items-center gap-1 px-1">
        <mat-icon [icIcon]="icPublic"></mat-icon>
        <span fxHide.xs> {{ selectedLanguage }} </span>
      </div>
    </button>

    <!-- Selected Language -->
    <!-- <div> -->
    <!-- <span fxHide.xs> {{ selectedLanguage }} </span> -->
    <!-- </div> -->

    <div class="px-1">
      <vex-toolbar-user></vex-toolbar-user>
    </div>

    <mat-menu
      #languageMenu="matMenu"
      overlapTrigger="false"
      xPosition="after"
      yPosition="below">
      <button mat-menu-item (click)="selectLanguage('en')">
        <!-- <mat-icon [icIcon]="emojioneUS"></mat-icon> -->
        <span> English </span>
      </button>
      <button mat-menu-item (click)="selectLanguage('zh-CN')">
        <!-- <mat-icon [icIcon]="emojioneCN"></mat-icon> -->
        <span> 简体中文 </span>
      </button>
      <button mat-menu-item (click)="selectLanguage('zh-TW')">
        <!-- <mat-icon [icIcon]="emojioneTW"></mat-icon> -->
        <span> 繁體中文 </span>
      </button>
      <button mat-menu-item (click)="selectLanguage('fr')">
        <!-- <mat-icon [icIcon]="emojioneFR"></mat-icon> -->
        <span> Français </span>
      </button>
      <button mat-menu-item (click)="selectLanguage('es')">
        <!-- <mat-icon [icIcon]="emojioneES"></mat-icon> -->
        <span> Español </span>
      </button>
      <button mat-menu-item (click)="selectLanguage('de')">
        <!-- <mat-icon [icIcon]="emojioneDE"></mat-icon> -->
        <span> Deutsche </span>
      </button>
    </mat-menu>
  </div>
</div>

<vex-navigation
  *ngIf="(isVerticalLayout$ | async) && isNavbarBelowToolbar$ | async"
  [fxHide]="mobileQuery"></vex-navigation>
